export const textIconCardGql = /* GraphQL */ `
... on bodyContent2022_textIconCards_BlockType {
  id
  typeHandle
  componentTheme:textIconCardProductsComponentTheme
  cardStyle:textIconCardProductsCardStyle
  alignCenter
  cards:textIconCardProducts {
    ... on textIconCardProducts_BlockType {
      cardDescription
      cardSubtitle
      cardTitle
      icon {
        ... on svgIcons_Asset {
          url
          title
        }
      }
      cardTheme:textIconCardProductsCardTheme
      cardLink {
        ariaLabel
        customText
        url
        target
        text
      }
    }
  }
}`;
